'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ITEM_OR_STRING = exports.ITEM = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var shape = _propTypes2.default.shape,
    oneOfType = _propTypes2.default.oneOfType,
    string = _propTypes2.default.string,
    any = _propTypes2.default.any;
var ITEM = exports.ITEM = shape({
  text: string,
  label: any,
  value: any
});

var ITEM_OR_STRING = exports.ITEM_OR_STRING = oneOfType([ITEM, string]);


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-input-enhancements/lib/shapes.js
// module id = 189
// module chunks = 0